import { render, staticRenderFns } from "./DescargaApp.vue?vue&type=template&id=17ad458e&scoped=true&"
import script from "./DescargaApp.vue?vue&type=script&lang=js&"
export * from "./DescargaApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad458e",
  null
  
)

export default component.exports